module.exports = __webpack_public_path__ + "img/Weapon_273.e6fa2cd5.png";